import {
  IProduct360Video,
  Product360Video
} from '@components/std-components/ProductMedia/Product360'
import {
  IProductImage,
  ProductImage
} from '@components/std-components/ProductMedia/ProductImage'
import React from 'react'

export enum ProductMediaType {
  staticImage = 'Static Image',
  threeSixty = 'Three Sixty',
  video = 'Video'
}

export interface ISwitchMedia {
  media?: IProductImage | IProduct360Video
  type?: ProductMediaType
}

export const SwitchMedia: React.FC<ISwitchMedia> = ({ media, type }) => {
  switch (type) {
    case ProductMediaType.staticImage:
      return <ProductImage {...(media as IProductImage)} />
    case ProductMediaType.threeSixty:
    case ProductMediaType.video:
      return <Product360Video {...(media as IProduct360Video)} />
    default:
      return null
  }
}
